import React from 'react';
import {
  CalendarProps,
  createHabitTrackerTemplateData,
  daysOfTheWeek,
} from './calendar.utils';

const GREEN_CHECK_URL =
  'https://www.labelsxpress.com/img/products/1542808628_QUALITY-CheckMarkGreen1.5diametercircle_checkmark.jpg';
const RED_X_URL =
  'http://sweetclipart.com/multisite/sweetclipart/files/imagecache/middle/x_mark_red_circle.png';

export function Calendar(props: CalendarProps) {
  const {
    weekNames,
    data,
    maxSuccessStreak,
    maxFailureStreak,
  } = createHabitTrackerTemplateData(props);
  return (
    <>
      <div className="grid grid-cols-7">
        {weekNames.map((weekName) =>
          daysOfTheWeek.map((dayOfTheWeek) => {
            const { date, result } = data[weekName][dayOfTheWeek];
            const firstWeek = 'week-1';
            const lastWeek = weekNames[weekNames.length - 1];
            return (
              <div
                className={`
                h-10
                w-10
                md:h-24
                md:w-24
                ${result === 'out of bounds' ? 'bg-gray-300' : ''}
                border-2
                ${weekName === firstWeek ? 'border-t-4 ' : ' '}
                ${weekName === lastWeek ? 'border-b-4 ' : ' '}
                ${dayOfTheWeek === 'Sunday' ? 'border-l-4' : ''}
                ${dayOfTheWeek === 'Saturday' ? 'border-r-4' : ''}
                ${
                  weekName === firstWeek && dayOfTheWeek === 'Sunday'
                    ? 'rounded-tl-2xl'
                    : ''
                }
                ${
                  weekName === firstWeek && dayOfTheWeek === 'Saturday'
                    ? 'rounded-tr-2xl'
                    : ''
                }
                ${
                  weekName === lastWeek && dayOfTheWeek === 'Sunday'
                    ? 'rounded-bl-2xl'
                    : ''
                }
                ${
                  weekName === lastWeek && dayOfTheWeek === 'Saturday'
                    ? 'rounded-br-2xl'
                    : ''
                }
                relative
              `}
                key={`${weekName}|${dayOfTheWeek}`}
                style={{
                  backgroundImage: `url(${
                    result === 'success'
                      ? GREEN_CHECK_URL
                      : result === 'failure'
                      ? RED_X_URL
                      : undefined
                  })`,
                  backgroundSize: '100%',
                }}
              >
                <div
                  className={`absolute top-0 left-0 m-1 rounded-full h-4 w-4 md:h-6 md:w-6 flex items-center justify-center bg-blue-500 text-white md:text-sm text-xs z-10`}
                >
                  {date}
                </div>
                {/* { result === 'success'
                  ? <img className="absolute top-2 left-2 md:w-20 w-6 z-0" src={GREEN_CHECK_URL} alt="Success!" />
                : result === 'failure'
                  ? <img className="absolute top-2 left-2 md:top-4 md:left-4 md:w-16 w-6 z-0" src={RED_X_URL} alt="FAILURE." /> 
                : undefined} */}
              </div>
            );
          })
        )}
      </div>
      <h2 className="text-2xl text-center">
        Max Success Streak: {maxSuccessStreak} (Goal: {'>='} 15)
      </h2>
      <h2 className="text-2xl text-center">
        Max Failure Streak: {maxFailureStreak} (Goal: {'<='} 1)
      </h2>
    </>
  );
}

export default Calendar;
